export default __webpack_public_path__ + "static/images/xiao-mi.ed04cbbf.png";